module.exports = __webpack_public_path__ + "img/expand_less.289667ca.svg";